var _defs, _circle, _path, _path2, _path3, _path4, _path5, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHygiene(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 8,
    x2: 56,
    y1: 8,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCFCE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBF7D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bottle",
    x1: 19,
    x2: 37,
    y1: 14,
    y2: 55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38BDF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0284C7"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 29,
    fill: "url(#bg)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0F766E",
    d: "M24 10h11v8H24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bottle)",
    d: "M19 19h21v36H19z",
    rx: 7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0F2FE",
    d: "M23 30h13v12H23z",
    rx: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#14B8A6",
    d: "M38 18h14v5H38z",
    rx: 2.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#0F766E",
    d: "M43 23h3v28h-3zM49 23h3v28h-3zM37 23h3v28h-3z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 14,
    r: 3,
    fill: "#7DD3FC"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 23,
    r: 2.4,
    fill: "#7DD3FC"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 13,
    r: 2.6,
    fill: "#5EEAD4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHygiene);
export default __webpack_public_path__ + "static/media/hygiene.0c67523a31ec0a9edb2a4b62285cd4f4.svg";
export { ForwardRef as ReactComponent };